export const profileSharingPath = 'profile-sharing-self-modal'
